// extracted by mini-css-extract-plugin
module.exports = {"gridForm":"ColumnMapping_gridForm__2M1N8"};